import React from "react";
import EventButton, {
  EventButtonVariant,
} from "../../shared/components/EventButton";
import CommunityNavigationStore from "../../navigation/communityNavigationStore";

interface RemoveGuestConfirmationProps {
  onConfirm: () => void;
}

const RemoveGuestConfirmation: React.FC<RemoveGuestConfirmationProps> = ({
  onConfirm,
}) => (
  <div className="text-center py-4">
    <h2 className="text-2xl font-nostalgic mb-4 pt-6 pb-6">
      Are you sure you want to remove <br /> this guest from the guest list?
    </h2>
    <div className="flex gap-4 justify-center">
      <EventButton
        variant={EventButtonVariant.PRIMARY_WHITE}
        onClick={() => {
          CommunityNavigationStore.setPopUpView(null);
          onConfirm();
        }}
        className="min-w-[100px]"
      >
        ⛔️ Yes, remove guest
      </EventButton>
    </div>
  </div>
);

export default RemoveGuestConfirmation;
